import { Box, Typography } from "@mui/material";
import * as React from "react";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { Translations } from "ui/Scripts/source/models/translations";
import { Base } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/framework/base";
import { AppUtils } from "../../../framework/appUtils";
import { infiniteListPageSize } from "../../../models/common/webConsts";
import * as userService from "../../../models/services/userService";
import { IUserListItem } from "../../../models/user/userListItem";
import { UserListItems } from "../../../models/user/userListItems";
import { ActionContainer } from "../../framework/ActionContainer";
import { Dialog } from "../../framework/Dialog/Dialog";
import { FormSectionTitle } from "../../framework/Form/FormSectionTitle";
import { List } from "../../framework/List/List";
import { ListSearchFilter } from "../../framework/List/ListSearchFilter";
import { CompanyDropdown } from "source/components/company/CompanyDropdown";
import { VerticalContainer } from "ui/Scripts/source/components/framework/VerticalContainer";

//SelectUserDialogList
export interface ISelectUserDialogListProps {
    companyId: string;
    ignoreUserIds?: string[];
    ignoreUserCodes?: string[];
    ignoreRecordUserConnected?: boolean;
    ignoreQrCodeUsers?: boolean;
    requireQrCodeUsers?: boolean;
    doNotIgnoreRecordUserConnectedUserCode?: string;
    hideUserGroups?: boolean;
    multiSelect?: boolean;
    intialized: boolean;
    selectedId: string;
    checkedIds: string[];
    onSetIntialized: (intialized: boolean) => void;
    onSetSelected: (selectedId: string, checkedIds: string[], selectedItems: IUserListItem[]) => void;
    onGetUserSelectListItems?: (companyId: string, pageSize: number, page: number, filter: string,
        ignoreUserIds: string[], ignoreUserCodes: string[], activityState: number, ignoreRecordUserConnected: boolean, ignoreQrCodeUsers: boolean, requireQrCodeUsers: boolean,
        doNotIgnoreRecordUserConnectedUserCode: string, sortColumn: string, sortOrderIsAsc: boolean) => Promise<UserListItems>;
}

export interface ISelectUserDialogListState {
    isLoading: boolean;
    pageSize: number;
    page: number;
    hasMore: boolean;
    filter: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    items: IUserListItem[];
}

export class SelectUserDialogList extends React.Component<ISelectUserDialogListProps, ISelectUserDialogListState> {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            pageSize: 10000,
            page: 1,
            hasMore: true,
            filter: "",
            sortColumn: "name",
            sortOrderIsAsc: true,
            items: []
        };
    }

    setSelected = (selectedId: string, checkedIds: string[]) => {
        const state = this.state;
        const ids = List.getSelectedIds(selectedId, checkedIds);
        this.props.onSetSelected(selectedId, checkedIds, state.items.filter(i => ids.indexOf(i.id) > -1));
    };

    searchItems = async (pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean, resetItems: boolean, refreshList: boolean) => {
        const props = this.props;
        const state = this.state;
        this.setState({ isLoading: true });
        const getUserSelectListItems = props.onGetUserSelectListItems ?? userService.getUserSelectListItems;
        const result = await AppUtils.callService(() => getUserSelectListItems(props.companyId, !refreshList ? pageSize : (page * infiniteListPageSize), !refreshList ? page : 1, filter,
            props.ignoreUserIds, props.ignoreUserCodes, 0, props.ignoreRecordUserConnected, props.ignoreQrCodeUsers, props.requireQrCodeUsers, props.doNotIgnoreRecordUserConnectedUserCode,
            sortColumn, sortOrderIsAsc), false, true, () => this.setState({ isLoading: false }));
        if (!result) return;
        const items = List.getListItems(state.items, props.selectedId, props.checkedIds, result.items, resetItems, refreshList);
        this.setState({
            page: !refreshList ? result.page : page,
            hasMore: result.hasMore,
            filter,
            sortColumn,
            sortOrderIsAsc,
            items: items.items
        });
        props.onSetIntialized(true);
        this.setSelected(items.selectedId, items.checkedIds);
    };

    componentDidMount(): void {
        const state = this.state;
        this.searchItems(state.pageSize, 1, state.filter, state.sortColumn, state.sortOrderIsAsc, true, false);
    }

    componentDidUpdate(prevProps: ISelectUserDialogListProps, prevState: ISelectUserDialogListState) {
        const props = this.props;
        const state = this.state;
        const prevCompanyId = prevProps.companyId ? prevProps.companyId : "";
        const companyId = props.companyId ? props.companyId : "";
        if (companyId === prevCompanyId &&
            Base.equalStrArrays(prevProps.ignoreUserIds, props.ignoreUserIds)) return;
        this.searchItems(state.pageSize, 1, state.filter, state.sortColumn, state.sortOrderIsAsc, true, false);
    }

    changeFilter = (filter: string) => {
        const state = this.state;
        this.searchItems(state.pageSize, 1, filter, state.sortColumn, state.sortOrderIsAsc, true, false);
    };

    handleSearchLines = (sortColumn: string, sortOrderIsAsc: boolean, nextPage: boolean) => {
        const state = this.state;
        this.searchItems(state.pageSize, !nextPage ? 1 : state.page + 1, state.filter, sortColumn, sortOrderIsAsc, !nextPage, false);
    };

    handleSetSelectedIds = (selectedId: string, checkedIds: string[]) => {
        this.setSelected(selectedId, checkedIds);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <VerticalContainer
                before={<>
                    <ActionContainer leftItems={
                        <ListSearchFilter
                            searchFilter={state.filter}
                            onSearchClick={this.changeFilter} />
                    } />
                </>}
                main={<>
                    <List
                        multiSelect={props.multiSelect}
                        intialized={props.intialized}
                        isLoading={state.isLoading}
                        hasMore={state.hasMore}
                        height="100%"
                        header={{
                            columns: [
                                { size: !props.hideUserGroups ? 3 : 4, column: "code", content: Translations.UserName },
                                { size: !props.hideUserGroups ? 4 : 8, column: "name", content: Translations.Name },
                                !props.hideUserGroups ? { size: 5, column: "groups", content: Translations.UserGroups } : null
                            ]
                        }}
                        lines={
                            state.items.map((item) => {
                                return {
                                    columns: [
                                        {
                                            column: "code",
                                            size: !props.hideUserGroups ? 3 : 4,
                                            content:
                                                <Box display="flex" alignItems="center">
                                                    <AvatarImage
                                                        id={item.code}
                                                        name={item.getName()}
                                                        image={item.picture}
                                                        tooltip={item.getName()}
                                                    />
                                                    <Typography sx={{ marginLeft: ".5rem" }}>{item.code}</Typography>
                                                </Box>
                                        },
                                        { size: !props.hideUserGroups ? 4 : 8, column: "name", content: item.getName() },
                                        !props.hideUserGroups ? { size: 5, column: "groups", content: item.userGroupsStr } : null
                                    ],
                                    id: item.id,
                                    classes: item.disabled ? "disabled" : ""
                                };
                            })
                        }
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        selectedId={props.selectedId}
                        checkedIds={props.checkedIds}
                        onSetSelectedIds={this.handleSetSelectedIds}
                        onSearchLines={this.handleSearchLines}
                    />
                </>}
            />
        );
    }
}

//SelectUserDialog
export interface ISelectUserDialogBaseProps {
    ignoreUserIds?: string[];
    ignoreUserCodes?: string[];
    ignoreRecordUserConnected?: boolean;
    ignoreQrCodeUsers?: boolean;
    requireQrCodeUsers?: boolean;
    doNotIgnoreRecordUserConnectedUserCode?: string;
    multiSelect?: boolean;
    title?: string;
    initiallySelectedIds?: string[];
    onCancel: () => void;
    onGetUserSelectListItems?: (companyId: string, pageSize: number, page: number, filter: string,
        ignoreUserIds: string[], ignoreUserCodes: string[], activityState: number, ignoreRecordUserConnected: boolean, ignoreQrCodeUsers: boolean, requireQrCodeUsers: boolean,
        doNotIgnoreRecordUserConnectedUserCode: string, sortColumn: string, sortOrderIsAsc: boolean) => Promise<UserListItems>
}

export interface ISelectUserDialogProps extends ISelectUserDialogBaseProps {
    companyId: string;
    hideUserGroups?: boolean;
    onOk: (users: IUserListItem[]) => void;
}

export interface ISelectUserDialogState {
    intialized: boolean;
    selectedId: string;
    checkedIds: string[];
    selectedItems: IUserListItem[];
}

export class SelectUserDialog extends React.Component<ISelectUserDialogProps, ISelectUserDialogState> {
    constructor(props: ISelectUserDialogProps) {
        super(props);
        this.state = {
            intialized: false,
            selectedId: null,
            checkedIds: props.initiallySelectedIds ?? [],
            selectedItems: []
        };
    }

    handleSetInitialized = (intialized: boolean) => {
        this.setState({
            intialized
        });
    };

    handleSetSelectedIds = (selectedId: string, checkedIds: string[], selectedItems: IUserListItem[]) => {
        this.setState({
            selectedId,
            checkedIds,
            selectedItems
        });
    };

    handleCancel = () => {
        this.props.onCancel();
    };

    handleOk = () => {
        const state = this.state;
        if (state.selectedItems.length < 1) return;
        this.props.onOk(state.selectedItems);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Dialog
                id="select-user-dialog"
                maxWidth="lg"
                maxHeight="726px"
                hide={!state.intialized}
                title={props.title ?? Translations.SelectUser}
                body={
                    <SelectUserDialogList
                        companyId={props.companyId}
                        ignoreUserIds={props.ignoreUserIds}
                        ignoreUserCodes={props.ignoreUserCodes}
                        ignoreRecordUserConnected={props.ignoreRecordUserConnected}
                        ignoreQrCodeUsers={props.ignoreQrCodeUsers}
                        requireQrCodeUsers={props.requireQrCodeUsers}
                        doNotIgnoreRecordUserConnectedUserCode={props.doNotIgnoreRecordUserConnectedUserCode}
                        hideUserGroups={props.hideUserGroups}
                        multiSelect={props.multiSelect}
                        intialized={state.intialized}
                        selectedId={state.selectedId}
                        checkedIds={state.checkedIds}
                        onSetIntialized={this.handleSetInitialized}
                        onSetSelected={this.handleSetSelectedIds}
                        onGetUserSelectListItems={props.onGetUserSelectListItems}
                    />
                }
                buttons={[
                    { title: Translations.Cancel, variant: "outlined", onClick: this.handleCancel },
                    { title: Translations.OK, variant: "confirmation", onClick: this.handleOk },
                ]}
                onClose={this.handleCancel}
            />
        );
    }
}

//SelectUserDialogWithCompanySelect
export interface ISelectUserDialogWithCompanySelectProps extends ISelectUserDialogBaseProps {
    companies: ICompanyMenuItem[];
    showUserGroupsCompanyId: string;
    onOk: (users: IUserListItem[], companyId :string) => void;
}

export interface ISelectUserDialogWithCompanySelectState extends ISelectUserDialogState {
    company: ICompanyMenuItem;
}

export class SelectUserDialogWithCompanySelect extends React.Component<ISelectUserDialogWithCompanySelectProps, ISelectUserDialogWithCompanySelectState> {
    constructor(props: ISelectUserDialogWithCompanySelectProps) {
        super(props);
        this.state = {
            company: props.companies.length ? props.companies[0] : null,
            intialized: false,
            selectedId: null,
            checkedIds: [],
            selectedItems: []
        };
    }

    handleSetInitialized = (intialized: boolean) => {
        this.setState({
            intialized
        });
    };

    handleSetSelectedIds = (selectedId: string, checkedIds: string[], selectedItems: IUserListItem[]) => {
        this.setState({
            selectedId,
            checkedIds,
            selectedItems
        });
    };

    handleCompanyChange = (company: ICompanyMenuItem) => {
        if (!company) return;
        this.setState({
            company
        });
    };

    handleCancel = () => {
        this.props.onCancel();
    };

    handleOk = () => {
        const state = this.state;
        if (state.selectedItems.length < 1) return;
        this.props.onOk(state.selectedItems, state.company.id);
    };

    render() {
        const props = this.props;
        const state = this.state;
        if (!state.company) return null;
        const title = props.title ?? Translations.SelectUser;
        return (
            <Dialog
                id="select-user-dialog-with-company"
                maxWidth="md"
                maxHeight="726px"
                hide={!state.intialized}
                title={title}
                body={
                    <VerticalContainer
                        before={<>
                            {props.companies.length > 1 &&
                                <>
                                    <FormSectionTitle>{Translations.SelectCompany}</FormSectionTitle>
                                    <CompanyDropdown
                                        company={state.company}
                                        companies={props.companies}
                                        onSetCompany={this.handleCompanyChange}
                                    />
                                </>
                            }
                            {props.companies.length > 1 &&
                                <FormSectionTitle>{title}</FormSectionTitle>
                            }
                        </>}
                        main={<>
                            <SelectUserDialogList
                                companyId={state.company.id}
                                ignoreUserIds={props.ignoreUserIds}
                                ignoreUserCodes={props.ignoreUserCodes}
                                ignoreRecordUserConnected={props.ignoreRecordUserConnected}
                                doNotIgnoreRecordUserConnectedUserCode={props.doNotIgnoreRecordUserConnectedUserCode}
                                hideUserGroups={state.company.id !== props.showUserGroupsCompanyId}
                                multiSelect={props.multiSelect}
                                intialized={state.intialized}
                                selectedId={state.selectedId}
                                checkedIds={state.checkedIds}
                                onSetIntialized={this.handleSetInitialized}
                                onSetSelected={this.handleSetSelectedIds}
                                onGetUserSelectListItems={props.onGetUserSelectListItems}
                            />
                        </>}
                    />
                }
                buttons={[
                    { title: Translations.Cancel, variant: "outlined", onClick: this.handleCancel },
                    { title: Translations.OK, variant: "confirmation", onClick: this.handleOk },
                ]}
                onClose={this.handleCancel}
            />
        );
    }
}